import React from 'react';
import {SwipeableDrawer} from "@mui/material";
import uiStore from "../lib/stores/uiStore";
import RoomList from "./RoomList";
import {observer} from "mobx-react";

const MobileRoomList = () => {

    return <SwipeableDrawer
            slotProps={{
                backdrop: {
                    invisible: true,
                }
            }}
            anchor={"bottom"}
            open={uiStore.roomListVisible}
            onOpen={() => uiStore.roomListVisible = true}
            onClose={() => uiStore.roomListVisible = false}
            PaperProps={{
                sx: {
                    width: "100%",
                    overflow: "initial"
                },
            }}
    >
        <RoomList/>
    </SwipeableDrawer>
};

export default observer(MobileRoomList);
